import { AlignTypes } from 'ui/tableHeader';
import { MetricIdentifier } from '../constants';
import {
  ExperimentHoldoutBreakdownDetail,
  ExperimentSummaryArray,
  ExperimentVariantBreakdownArray,
  ExperimentVariantBreakdownDetail,
  ExperimentVariantSummary,
  MetricOption,
} from './selectors';

export type VariantBreakdownCardProps = {
  options: MetricOption<string>[];
  metricMap: Record<string, MetricIdentifier>;
  variantList: ExperimentVariantBreakdownArray;
};

export type VARIANT_TABLE_COLUMN = {
  id: string;
  label: string;
  isSortable: boolean;
  isRightAligned: boolean;
};

export type VariantRowItems = ExperimentSummaryArray | ExperimentVariantBreakdownArray;
export type VariantRowItem =
  | ExperimentVariantBreakdownDetail
  | ExperimentVariantSummary
  | ExperimentHoldoutBreakdownDetail;

export type RowDataProps = {
  row: VariantRowItem;
};

export type ExperimentSummaryRowDataProps = {
  row: ExperimentVariantSummary;
};

export type ExperimentVariantBreakdownRowDataProps = {
  row: ExperimentVariantBreakdownDetail;
};

export type ExperimentHoldoutRowDataProps = {
  row: ExperimentHoldoutBreakdownDetail;
};

export type ExperimentVariantRowDataProps = {
  row: ExperimentVariantSummary | ExperimentVariantBreakdownDetail;
};

export enum CellAlignTypes {
  flexStart = 'flex-start',
  flexEnd = 'flex-end',
  flexCenter = 'center',
}

export type ExperimentColumnData = {
  /** This will be used as the cell's key */
  value: string;
  align: AlignTypes;
  HeaderCell: () => JSX.Element;
  RowCell: (row: RowDataProps) => JSX.Element;
};

export type DerivationMetrics = {
  variantSends: number;
  variantExperimentWinningCriteria: number;
  controlExperimentSends: number;
  controlExperimentWinningCriteria: number;
};

export enum TABLE_EXPORT {
  CURRENT = 'export-current',
  ALL = 'export-all',
}
